import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["messageRoot", "errorCode", "hasJSX"];
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import { captureException, createBoardError } from '../../error/utils';
import { jsx as _jsx } from "react/jsx-runtime";
export const FormattedErrorMessage = _ref => {
  let {
      messageRoot,
      errorCode,
      hasJSX
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const overrideKey = hasJSX ? `${messageRoot}.${errorCode}_jsx` : `${messageRoot}.${errorCode}`;
  if (isValidI18nKey(overrideKey)) {
    return hasJSX ? /*#__PURE__*/_jsx(FormattedJSXMessage, Object.assign({
      message: overrideKey
    }, rest)) : /*#__PURE__*/_jsx(FormattedMessage, Object.assign({
      message: overrideKey
    }, rest));
  }
  captureException(createBoardError(`Translation key ${messageRoot} not found for error code ${errorCode}`));
  return /*#__PURE__*/_jsx(FormattedMessage, Object.assign({
    message: `${messageRoot}.all`
  }, rest));
};